import { IRootState } from '@/store/state';
import { ActionContext, ActionTree } from 'vuex';
import { CostAnalysisService } from '@/modules/costAnalysis/services';
import * as AT from './actionTypes';
import * as MT from './mutationsTypes';
import {
  AllAnalysisData,
  AnalysisParam,
  AnalysisParamWithFilter
} from '@/modules/costAnalysis/types';
import { IAssetOwnerState } from '@/modules/assetOwner/store/state';
import { FetchRootInvestmentsRequest, PensionScheme } from '../types';
import { AssetOwnerService } from '../services';

/**
 * --------------------------------------------------
 *  Asset Owner Actions
 * --------------------------------------------------
 **/
export const AssetOwnerActions: IAssetOwnerActions = {
  [AT.FETCH_COST_ANALYSIS_DETAILS]: (
    { commit },
    params: AnalysisParamWithFilter
  ): Promise<AllAnalysisData | boolean> => {
    return CostAnalysisService.getAnalysisByFilter(params).then(
      (analysis: any) => {
        commit(MT.SET_SCHEME_COST_ANALYSIS_DETAILS, analysis);
        return analysis;
      }
    );
  },
  [AT.FETCH_ENTITY_ROOT_INVESTMENTS]: (
    { commit },
    params: FetchRootInvestmentsRequest
  ): Promise<PensionScheme[]> => {
    return AssetOwnerService.fetchRootInvestments(params).then(schemes => {
      commit(MT.SET_ENTITY_ROOT_INVESTMENTS, schemes);
      commit(
        MT.SET_ENTITY_ROOT_INVESTMENT_IDS,
        schemes.map(scheme => scheme.id)
      );
      return schemes;
    });
  }
};

/**
 * --------------------------------------------------
 *  Asset Owner Action Context Interface
 * --------------------------------------------------
 **/
export interface IAssetOwnerActionContext
  extends ActionContext<IAssetOwnerState, IRootState> {}

/**
 * --------------------------------------------------
 *  Asset Owner Actions Interface
 * --------------------------------------------------
 **/
export interface IAssetOwnerActions
  extends ActionTree<IAssetOwnerState, IRootState> {
  [AT.FETCH_COST_ANALYSIS_DETAILS](
    context: IAssetOwnerActionContext,
    params: AnalysisParam
  ): Promise<AllAnalysisData | boolean>;
}
